import { atom, useAtom, useSetAtom, WritableAtom } from "jotai";

const globalErrorAtom = atom<Error | null>(null) as WritableAtom<
  Error | null,
  unknown[],
  unknown
>;

export const useGlobalError = () => {
  const atom = useAtom(globalErrorAtom);
  return atom;
};

export const useSetGlobalError = () => useSetAtom(globalErrorAtom);
